import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M94.171 50.452L51.924 5.718l-.05-.054-.007-.007c-.018-.019-.043-.025-.061-.044s-.024-.043-.043-.06a2.348 2.348 0 0 0-.371-.232 2.51 2.51 0 0 0-.432-.27 2.428 2.428 0 0 0-.476-.107 1.5 1.5 0 0 0-.966 0 2.419 2.419 0 0 0-.475.107 2.569 2.569 0 0 0-.436.272 2.423 2.423 0 0 0-.367.23c-.019.018-.025.042-.043.06s-.044.025-.061.044l-.008.007-.051.054L5.829 50.452a2.566 2.566 0 0 0 3.732 3.524l4.3-4.558v43.153a2.566 2.566 0 0 0 2.566 2.566h67.142a2.566 2.566 0 0 0 2.566-2.566V49.418l4.3 4.558a2.566 2.566 0 1 0 3.732-3.524zM81 90.005H19V44.32l31-33.146 31 33.147z'

const IconHome: FC<IconProps> = props => <SvgIcon {...props} path={PATH} />

export default IconHome
